import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular';

import { TranslateModule } from '@ngx-translate/core';
import { SwiperModule } from 'swiper/angular';

import { TooltipBoxComponent } from './components/atomic/tooltip/tooltip-box.component';
import { ValidationTextComponent } from './components/atomic/validation-text/validation-text.component';
import { ConfirmDialogComponent } from './components/molecules/confirm-dialog/confirm-dialog.component';
import { FirebaseCardComponent } from './components/molecules/firebase-card/firebase-card.component';
import { FormFieldCheckboxListComponent } from './components/molecules/form-field-checkbox-list/form-field-checkbox-list.component';
import { FormFieldDateComponent } from './components/molecules/form-field-date/form-field-date.component';
import { FormFieldInputComponent } from './components/molecules/form-field-input/form-field-input.component';
import { FormFieldNumberComponent } from './components/molecules/form-field-number/form-field-number.component';
import { FormFieldPasswordComponent } from './components/molecules/form-field-password/form-field-password.component';
import { FormFieldPhoneComponent } from './components/molecules/form-field-phone/form-field-phone.component';
import { FormFieldRadioComponent } from './components/molecules/form-field-radio/form-field-radio.component';
import { FormFieldSelectComponent } from './components/molecules/form-field-select/form-field-select.component';
import { FormFieldTextareaComponent } from './components/molecules/form-field-textarea/form-field-textarea.component';
import { FormFieldVerificationCodeComponent } from './components/molecules/form-field-verification-code/form-field-verification-code.component';
import { HeaderAdminFullScreenComponent } from './components/molecules/header-admin-full-screen/header-admin-full-screen.component';
import { HeaderWithCloseButtonComponent } from './components/molecules/header-with-close-button/header-with-close-button.component';
import { HeaderWithLogoComponent } from './components/molecules/header-with-logo/header-with-logo.component';
import { HeaderWithLogoAndRightButtonComponent } from './components/molecules/header-with-logo-and-right-button/header-with-logo-and-right-button.component';
import { HeaderWithLogoAndTimerComponent } from './components/molecules/header-with-logo-and-timer/header-with-logo-and-timer.component';
import { HeaderWithMenuComponent } from './components/molecules/header-with-menu/header-with-menu.component';
import { BannerSkeletonComponent } from './components/molecules/loading-skeleton/banner-skeleton/banner-skeleton.component';
import { CarouselCardSkeletonComponent } from './components/molecules/loading-skeleton/carousel-card-skeleton/carousel-card-skeleton.component';
import { PointsProgressSkeletonComponent } from './components/molecules/loading-skeleton/points-progress-skeleton/points-progress-skeleton.component';
import { ProgressLogoComponent } from './components/molecules/progress-logo/progress-logo.component';
import { ResponsiveModalHeaderComponent } from './components/molecules/responsive-modal-header/responsive-modal-header.component';
import { CarouselCardComponent } from './components/organisms/carousel/carousel-card/carousel-card.component';
import { CarouselEmptyComponent } from './components/organisms/carousel/carousel-empty/carousel-empty.component';
import { HorizontalCarouselComponent } from './components/organisms/carousel/horizontal-carousel/horizontal-carousel.component';
import { VerticalCarouselComponent } from './components/organisms/carousel/vertical-carousel/vertical-carousel.component';
import { DataTableComponent } from './components/organisms/data-table/data-table.component';
import { SurveyFooterComponent } from './components/organisms/survey-footer/survey-footer.component';
import { SurveyHeaderComponent } from './components/organisms/survey-header/survey-header.component';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { ScrollbarViewDirective } from './directives/scroll-bar-view.directive';
import { TooltipDirective } from './directives/tooltip.directive';
import { ScrollViewPortCustomHeightDirective } from './directives/viewport-custom-height.directive';

@NgModule({
  imports: [CommonModule, FormsModule, FontAwesomeModule, IonicModule, ReactiveFormsModule, RouterModule, ScrollingModule, SwiperModule, TranslateModule],
  declarations: [
    AutoFocusDirective,
    BannerSkeletonComponent,
    HorizontalCarouselComponent,
    CarouselCardComponent,
    CarouselCardSkeletonComponent,
    CarouselEmptyComponent,
    ConfirmDialogComponent,
    VerticalCarouselComponent,
    DataTableComponent,
    FirebaseCardComponent,
    FormFieldCheckboxListComponent,
    FormFieldDateComponent,
    FormFieldInputComponent,
    FormFieldNumberComponent,
    FormFieldPasswordComponent,
    FormFieldPhoneComponent,
    FormFieldRadioComponent,
    FormFieldSelectComponent,
    FormFieldTextareaComponent,
    FormFieldVerificationCodeComponent,
    HeaderAdminFullScreenComponent,
    HeaderWithCloseButtonComponent,
    HeaderWithLogoComponent,
    HeaderWithLogoAndTimerComponent,
    HeaderWithLogoAndRightButtonComponent,
    HeaderWithMenuComponent,
    PointsProgressSkeletonComponent,
    ProgressLogoComponent,
    ResponsiveModalHeaderComponent,
    ScrollbarViewDirective,
    ScrollViewPortCustomHeightDirective,
    SurveyFooterComponent,
    SurveyHeaderComponent,
    TooltipBoxComponent,
    TooltipDirective,
    ValidationTextComponent
  ],
  exports: [
    AutoFocusDirective,
    BannerSkeletonComponent,
    CarouselCardSkeletonComponent,
    HorizontalCarouselComponent,
    VerticalCarouselComponent,
    DataTableComponent,
    FirebaseCardComponent,
    FormFieldCheckboxListComponent,
    FormFieldDateComponent,
    FormFieldInputComponent,
    FormFieldNumberComponent,
    FormFieldPasswordComponent,
    FormFieldPhoneComponent,
    FormFieldRadioComponent,
    FormFieldSelectComponent,
    FormFieldTextareaComponent,
    FormFieldVerificationCodeComponent,
    HeaderAdminFullScreenComponent,
    HeaderWithCloseButtonComponent,
    HeaderWithLogoComponent,
    HeaderWithLogoAndRightButtonComponent,
    HeaderWithLogoAndTimerComponent,
    HeaderWithMenuComponent,
    PointsProgressSkeletonComponent,
    ProgressLogoComponent,
    ResponsiveModalHeaderComponent,
    ScrollbarViewDirective,
    ScrollViewPortCustomHeightDirective,
    SurveyFooterComponent,
    SurveyHeaderComponent,
    TooltipDirective,
    ValidationTextComponent
  ]
})
export class UiModule {}
